import React from 'react';
import Sectionbreak from './Sectionbreak';

const partners = [
  {
    name: 'Google',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg',
  },
  {
    name: 'Microsoft',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg',
  },
  {
    name: 'Amazon',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg',
  },
  {
    name: 'IBM',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg',
  },
];

function Partners() {
  return (
    <section className="py-16 px-6">
      <Sectionbreak
      title='Our Trusted'
      highlight='Partners'
      description='We proudly collaborate with industry leaders and innovators.'
      />
    </section>
  );
}

export default Partners;
